import axios from 'axios';

import { notifications } from '@mantine/notifications';

import { ProjectDto, ProjectUploadDto } from '../../api/models';
import { usePutApiProjectsId } from '../../api/projects/projects.ts';
import ProjectModal from './ProjectModal.tsx';

interface ProjectEditModalProps {
    project: ProjectDto;
    refetch: () => Promise<ProjectDto[]>;
    opened: boolean;
    close: () => void;
}

const ProjectEditModal = ({
    project,
    refetch,
    opened,
    close
}: ProjectEditModalProps) => {
    const {
        mutateAsync: updateProject,
        error,
        isPending
    } = usePutApiProjectsId(); // ← your update mutation

    const handleUpdate = async (data: ProjectUploadDto) => {
        try {
            await updateProject({ id: project.id, data });

            notifications.show({
                title: 'Project Updated',
                message: `${data.name} updated! ✔️`,
                loading: false,
                withCloseButton: true,
                autoClose: 2000
            });
        } catch (err) {
            const errorMessage =
                axios.isAxiosError(err) && err.response
                    ? `Server error: ${err.response.status} ${err.response.statusText}`
                    : 'An unexpected error occurred ❌';

            notifications.show({
                title: 'Project Update Failed',
                message: errorMessage,
                loading: false,
                withCloseButton: true,
                autoClose: 5000,
                color: 'red'
            });
        }
    };

    return (
        <ProjectModal
            opened={opened}
            onClose={close}
            onSubmit={handleUpdate}
            error={error}
            isPending={isPending}
            refetch={refetch}
            project={project}
            title='Edit Project'
        />
    );
};

export default ProjectEditModal;
